// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-length/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springLengthEN: PageEntry = {
  id: "post.federlaenge",
  locale: "en",
  slug: "spring-length",
  seo: {
    title: "Glossary: Spring length explained simply | Dietz GmbH",
    description: "The spring length refers to the free, unloaded length of a spring when it is in its natural state. This length is an important parameter in determining the spring characteristics a",
  },
  type: "post",
  h1: "Glossary: Spring length explained simply",
  intro: "The spring length refers to the free, unloaded length of a spring when it is in its natural state. This length is an important parameter in determining the spring characteristics and its possible applications. In the case of stretched or compressed springs, the actual length is changed compared to the free length, which influences the spring force. The spring length is a decisive factor in the design of spring systems, as it is directly related to the spring constant and other mechanical properties.",
  blocks: [

  ],
};
